import { k } from "../kaplay";

k.loadRoot("./");

k.loadSound("music", "sounds/music.mp3");
k.loadSound("hit", "sounds/hit.wav");
k.loadSound("shoot", "sounds/shoot.wav");
k.loadSound("death", "sounds/death.wav");